module.exports = __webpack_public_path__ + "img/logo-build.e2c9e51e.png";